import {useEffect, useState} from "react";
import {host, isImage, StyleHTMLAttributes} from "../../utils";

const Question = ({ q, helpers }: any) => {
  const { save, storage, step } = helpers;
  const [highlight, setHighlight] = useState(false);

  return <>
    <div className="question">
      <h2>{q?.question}</h2>
      <br />
      <div className="content">
        {isImage(q?.image) && <div className="image">
          <img className="img" src={`${host}/${q?.image}`} alt="Ilustrativna slika" />
        </div>}
        <div className="text">
          {/*<p><b>{q?.question}</b></p>*/}
          {/*<br />*/}
          <ul className="answers">
            {q?.answers.map((a: any, i: number) => 
              <li className={`item`} key={i}>
                <div className="bullet" onClick={save(step, i)}/><div className={`text ${storage[step]?.answer == i && 'highlight'}`} onClick={save(step, i)}>{a.answer}</div>
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>

    <style jsx="true">
      {`
        .question {
          --space: 2rem;
          --breakpoint: 768px;

          .content {
            display: flex;
            gap: var(--space);

            @media (max-width: 60rem) {
              flex-direction: column;
            }

            .image {
              max-width: 50%;
              @media (max-width: 60rem) {
                max-width: 100%;
              }
            }
            .img {
              display: block;
              width: 100%;
            }
            .answers {
              list-style: none;
              {/* list-style-image: url('/images/teaser/live2.svg'); */}
              margin: 0;
            }
            .item {
              display: flex;
              align-items: center;
              .bullet {
                display: inline-block;
                width: 1rem;
                height: 1rem;
                margin-right: 1rem;
                border: 1px solid grey;
                border-radius: 50%;
              }
              &:hover {
                .bullet {
                  background-color: rgb(99 102 241);
                }
                .text {
                  background-color: #f0f0f0;
                }
              }
            }


          .answers {
            margin-left: var(--space);
            .item {
              cursor: pointer;

              .text {
                display: flex;
                align-items: center;
                min-height: 2.5rem;
                padding: 0.5rem 1rem;
                border-radius: 0.5rem;

                &.highlight {
                  box-sizing: border-box;
                  border-radius: 0.5rem;
                  border: 1px solid #cbcbcb;
                }
              }
            }
          }
        }

      `}
    </style>
  </>
}
export default Question;